import { trackEventAndOmitTypeName } from './trackEventAndOmitTypeName';

export enum AccordionInteraction {
  collapse = 'collapse',
  expand = 'expand',
}

export interface AccordionInteractionEventData {
  schema: string;
  data: {
    event_name: string;
    user_action: AccordionInteraction;
    in_page_source: string;
    accordion_copy: string;
  };
}

export const trackAccordionInteraction = (
  eventData?: AccordionInteractionEventData | null,
): void => {
  if (!eventData) return;
  trackEventAndOmitTypeName(eventData);
};
